import { FileInformationConverter } from './FileInformationConverter';
import BaseMailboxFileItem from 'owa-service/lib/contract/BaseMailboxFileItem';
import MailboxFileAttachmentItem from 'owa-service/lib/contract/MailboxFileAttachmentItem';
import MailboxCloudAttachmentItem from 'owa-service/lib/contract/MailboxCloudAttachmentItem';
import SharepointFileItem from 'owa-service/lib/contract/SharepointFileItem';
import BaseFileInformation from 'owa-group-files-hub-store/lib/Schema/BaseFileInformation';
import AttachmentFileInformation from 'owa-group-files-hub-store/lib/Schema/AttachmentFileInformation';
import CloudAttachmentFileInformation from 'owa-group-files-hub-store/lib/Schema/CloudAttachmentFileInformation';
import SharePointFileInformation from 'owa-group-files-hub-store/lib/Schema/SharePointFileInformation';
import FileActivityType from 'owa-service/lib/contract/FileActivityType';
import MailboxFileType from 'owa-service/lib/contract/MailboxFileType';
import { FileType, FileActivity } from 'owa-group-files-hub-store/lib/Schema/BaseFileInformation';
import { MessageItem } from 'owa-group-files-hub-store/lib/Schema/AttachmentFileInformation';
import { ProviderType } from 'owa-group-files-hub-store/lib/Schema/CloudAttachmentFileInformation';

export const MaxFiles = 5;

// converter for GetFileItems response
export class FileInformationConverterForGetFileItems implements FileInformationConverter {
    private files: BaseMailboxFileItem[];
    private groupSmtpAddress: string;
    private retrievedTime: Date;

    constructor(files: BaseMailboxFileItem[], groupSmtpAddress: string, retrievedTime: Date) {
        this.files = files;
        this.groupSmtpAddress = groupSmtpAddress;
        this.retrievedTime = retrievedTime;
    }

    getMessageItem(file: MailboxFileAttachmentItem): MessageItem {
        if (file.MessageList.length > 0) {
            let message: MessageItem = {
                sender: file.LastModifiedBy,
                subject: file.MessageList[0].Subject,
                conversationId:
                    file.MessageList[0].ConversationId != null
                        ? file.MessageList[0].ConversationId.Id
                        : null,
                itemId: file.MessageList[0].ItemId != null ? file.MessageList[0].ItemId.Id : null,
            };
            return message;
        }
        return null;
    }

    getProviderType(providerType: string): ProviderType {
        switch (providerType) {
            case 'OneDrivePro':
                return ProviderType.OneDrivePro;
            case 'GDrive':
                return ProviderType.GDrive;
            case 'Box':
                return ProviderType.Box;
            case 'DropBox':
                return ProviderType.Dropbox;
            default:
                return ProviderType.OneDrivePro; //TODO - throw error if not any of the above provider type
        }
    }

    encodePoundPercent(fileUrl: string): string {
        const replacePound = /#/gi;
        const replacePercent = /%/gi;
        return fileUrl.replace(replacePercent, '%25').replace(replacePound, '%23');
    }

    getFileInformation(): BaseFileInformation[] {
        let fileList: BaseFileInformation[] = [];

        for (let file of this.files.slice(0, MaxFiles)) {
            let fileInformation: BaseFileInformation = {
                name: file.Name,
                id: file.Id,
                size: file.Size,
                extension: file.Extension,
                fileModifiedTime: file.FileDateTimeModified,
                lastModifiedBy: file.LastModifiedBy,
                fileActivity: FileActivity.None,
                fileType: FileType.None,
                groupSmtpAddress: this.groupSmtpAddress,
                retrievedTime: this.retrievedTime,
            };

            switch (file.FileType) {
                case MailboxFileType.ClassicAttachment:
                    let fileAsClassic = file as MailboxFileAttachmentItem;
                    let classicFile: AttachmentFileInformation = fileInformation as AttachmentFileInformation;
                    classicFile.fileType = FileType.ClassicAttachment;
                    classicFile.fileActivity = FileActivity.Attached;
                    classicFile.message = this.getMessageItem(fileAsClassic);
                    classicFile.attachmentId =
                        fileAsClassic.AttachmentId != null ? fileAsClassic.AttachmentId.Id : null;
                    classicFile.contentType = fileAsClassic.ContentType;
                    fileList.push(classicFile);
                    break;
                case MailboxFileType.ModernAttachment:
                    let fileAsCloud = file as MailboxCloudAttachmentItem;
                    let cloudyFile: CloudAttachmentFileInformation = fileInformation as CloudAttachmentFileInformation;
                    cloudyFile.fileType = FileType.CloudAttachment;
                    cloudyFile.fileActivity = FileActivity.Attached;
                    cloudyFile.message = this.getMessageItem(fileAsCloud);
                    cloudyFile.attachmentId =
                        fileAsCloud.AttachmentId != null ? fileAsCloud.AttachmentId.Id : null;
                    cloudyFile.contentType = fileAsCloud.ContentType;
                    cloudyFile.url = fileAsCloud.FileUrl;
                    cloudyFile.providerType = this.getProviderType(fileAsCloud.ProviderType);
                    cloudyFile.siteId = fileAsCloud.SiteId;
                    cloudyFile.webId = fileAsCloud.WebId;
                    fileList.push(cloudyFile);
                    break;
                case MailboxFileType.SharePoint:
                    let fileAsSharePointFile = file as SharepointFileItem;
                    let spFile: SharePointFileInformation = fileInformation as SharePointFileInformation;

                    spFile.fileType = FileType.SharePointFile;
                    spFile.fileActivity =
                        fileAsSharePointFile.Activity == FileActivityType.Uploaded
                            ? FileActivity.Uploaded
                            : FileActivity.Modified;
                    spFile.createdTime = fileAsSharePointFile.CreatedTime;
                    spFile.createdBy = fileAsSharePointFile.CreatedBy;
                    spFile.url = this.encodePoundPercent(fileAsSharePointFile.FileUrl);
                    spFile.siteId = fileAsSharePointFile.SiteId;
                    spFile.webId = fileAsSharePointFile.WebId;
                    spFile.siteUrl = fileAsSharePointFile.SiteUrl;
                    spFile.thumbnailUrlTemplate = fileAsSharePointFile.ThumbnailUrlTemplate;
                    spFile.webUrl = fileAsSharePointFile.WebUrl;
                    fileList.push(spFile);
                    break;
                default:
                    break;
            }
        }

        return fileList;
    }
}
